'use strict';

import React                from 'react';
import ReactDOM             from 'react-dom';
import {Treebeard}            from 'react-treebeard';
import Avatar               from 'material-ui/Avatar';
import ListItem             from 'material-ui/List/ListItem';
import NotificationsIcon    from 'material-ui/svg-icons/social/notifications';
import PersonAdd    from 'material-ui/svg-icons/social/person-add';
import IconButton           from 'material-ui/IconButton';
import Badge                from 'material-ui/Badge';
import {Link}                 from 'react-router-dom';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../services/fetchTools';

class LocationMenu2 extends React.Component {
    constructor(props){
        super(props);
        this.state = {temp_value: '', customers: []}; //TODO - Fix it.
        this.onToggle = this.onToggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.searchCustomer = this.searchCustomer.bind(this);
    }
    onToggle(node, toggled){
        if(this.state.cursor){this.state.cursor.active = false;}
        node.active = true;
        if(node.children){ node.toggled = toggled; }
        this.setState({ cursor: node });//TODO - Fix it.
        this.props.reloadData(node.id);
    }
    getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/customer_list/search/?search=${this.state.temp_value}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({ customers: data.results});
        })
       .catch(error => error);
  }
    handleChange(event){
      console.log(event.target.value);
      this.setState({temp_value: event.target.value});
    }
    searchCustomer() {
    {this.state.temp_value?this.getSearchList(this.state.temp_value):
      alert('Search cannot be blank')}
  }

    render(){
        console.log("theere props");
        console.log(this.props);
        console.log(this.props.access);
        console.log(this.props.user);
        let avatar;
        if(this.props.user){
          avatar = <div> 
          <div style={{display: 'flex', justifyContent: 'center', paddingTop: '7%', flexDirection: 'column'}}>
            <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: '5%', marginLeft: '23%'}}>
              <div>
                <Avatar size={90} src={`https://api.sporthood.in/${this.props.user.photo}`} />
              </div>
              <div style={{color: '#ffff', marginLeft: '25px'}}>
                <p style={{fontSize: '15px'}}>{this.props.user.name}</p>
              </div>
            </div>
            {
              this.props.access != "Technichal Partner" ?
              <div style={{display: 'flex', justifyContent: 'center', paddingTop: '7%', flexDirection: 'column'}}>
              <button className="btn" style={{border: 'none', backgroundColor: '#ece15a', float: 'left', margin: '5px',}}>
                <Link to={`/partnerNotification`}> 
                <i className="fa fa-bell-o" style={{fontSize: 'medium', color: '#000'}}></i>
                  <span style={{fontSize: '100%',  margin: '4px', color: '#000'}}>TICKETS</span>
                </Link>
            </button>
            <button className="btn" style={{border: 'none', backgroundColor: '#ece15a', float: 'left', margin: '5px'}}>
                <Link to={`/crud/addlead`}> 
                  <i className="fa fa-plus-circle" style={{fontSize: 'medium', color: '#000'}}></i>
                  <span style={{fontSize: '100%', margin: '4px', color: '#000'}}>Add Lead</span>
                </Link>
            </button>
            </div>
            :
            <div>
            </div>
            }
            
          </div>
          <div>
          {
            this.props.access != "Technichal Partner" ?
            <div className="input-group" style={{padding: '1%', marginBottom: '10px'}}>
            <input type="text" name="searchinput" className="form-control" placeholder="Search Customer..." onChange={this.handleChange}/>
            <span className="input-group-btn"><button name="search" id="search-btn" className="btn btn-flat" onClick={this.searchCustomer}><i className="fa fa-search"></i></button></span>
          </div>
          :
          <div>
          </div>
          }
          <div style={{marginBottom: '4px'}}>
          {
            this.state.customers ?
            this.state.customers.map((cust, index)=>(
              <div key={index} style={{padding: '1%',border: '1px solid #9ea5aa', }}>
              <Link to={`../../crud/customerDetails/${cust.id}`}>
                <Avatar size={35} src={`${cust.user.photo}`} />
                <span style={{color: '#FFFFFF', textAlign: 'center', marginLeft: '10px', fontSize: '14px', fontWeight: 'bold'}}>{cust.user.name} - {cust.user.mobile_no}</span>
              </Link>
              </div>
              ))
            :
            <div>
            </div>
          }
          </div>
          </div>
        </div>
        } else {
          avatar = null
        }

        return (
            <div>
              {avatar}
              <Treebeard
                  data={this.props.data}
                  onToggle={this.onToggle}
              />
            </div>
        );
    }
}

export default LocationMenu2;



// WEBPACK FOOTER //
// ./src/app/components/locationMenu/LocationMenu2.js